(ns fablo-offers.app.components.form
  (:require ["@chakra-ui/react" :as ch]
            ["@iconify/react" :as iconify]
            ["final-form-focus" :as final-form-focus]
            ["react-final-form" :as rff]
            ["react-icons/fa" :as icons]
            [applied-science.js-interop :as j]
            [cljs-bean.core :refer [->clj ->js] :as bean]
            [cljs.reader :as edn]
            [clojure.string :as string]
            [fablo-offers.app.components.app :as app]
            [fablo-offers.common.api :as api]
            [fablo-offers.common.components.forms :as form]
            [fablo-offers.common.lib.hooks :as hooks]
            [fablo-offers.common.lib.i18n :as i18n :refer [language]]
            [fablo-offers.common.state :as s]
            [fablo-offers.common.tracking :as tracking :refer [track get-tracking-params]]
            [malli.core :as m]
            [malli.util :as mu]
            [reitit.frontend.easy :as rfe]
            [rumext.alpha :as mf]
            [tick.core :as tick]
            [promesa.core :as p]))

(i18n/add-translations
 :en
 :form
 {:next "Next"
  :back "Back"
  :confirm "Confirm"
  :confirm-and-order "Confirm\nand order"
  :confirm-and-pay "Order\nand pay"
  :confirm-pay-later "ORDER & PAY LATER"
  :choose "Choose..."
  :required-field "Required field"})

(i18n/add-translations
 :pl
 :form
 {:next "Dalej"
  :back "Cofnij"
  :confirm "Potwierdź"
  :confirm-and-order "Potwierdzam\ni zamawiam"
  :confirm-and-pay "Zamawiam\ni płacę"
  :confirm-pay-later "POTWIERDŹ I ZAPŁAĆ POŹNIEJ"
  :choose "Wybierz..."
  :required-field "Pole wymagane"})

(def offer-ctx (mf/create-context))
(def offer-ctx-provider (mf/provider offer-ctx))

(defn add-price-label [pricing name v label]
  (if-let [prices (->> pricing
                       (filter #(and (= (:type %) :claim-value)
                                     (= (:path %) name)))
                       first
                       :pricing)]
    (str label
         (when-let [p (get-in prices [v :price])]
                     ; fixme, format currency
           (str " (" (.toFixed p) " PLN)")))
    label))

(mf/defc select
  {::mf/register app/components
   ::mf/register-as :form/select}
  [{:keys [name label schema placeholder options]}]
  (let [t (hooks/use-t "form")
        pricing (:pricing (mf/use-ctx offer-ctx))]
    [:& form/field
     {:name name
      :label (t label)
      :component ch/Select
      :validate (form/malli-validator t schema)
      :cmp-params {:placeholder (or (t placeholder) (t "choose"))
                   :children (mf/html
                              (for [x options]
                                [:option
                                 {:value (:value x)
                                  :key (:value x)}
                                 (add-price-label pricing name (:value x) (:label x))]))}}]))

(mf/defc radio
  {::mf/register app/components
   ::mf/register-as :form/radio}
  [{:keys [name label tooltip options schema without-price disabled default-value]}]
  (let [t (hooks/use-t "form")
        pricing (:pricing (mf/use-ctx offer-ctx))]
    [:& form/field
     {:name name
      :label (t label)
      :tooltip (t tooltip)
      :component ch/RadioGroup
      :initialValue default-value
      :validate (form/malli-validator t schema)
      :format (fn [x] (pr-str x))
      :parse (fn [x] (edn/read-string x))

      :cmp-params
      {:children
       [(mf/html
         [:> ch/Stack {:key "1"}
          (for [x options]
            [:> ch/Radio
             {:size :lg
              :bg :white
              :key (:value x)
              :value (pr-str (:value x))
              :align-items :start
              :isDisabled disabled}
             [:span {:dangerouslySetInnerHTML
                     #js {:__html (if without-price
                                    (t (:label x))
                                    (add-price-label pricing name (:value x) (t (:label x))))}}]])])]}}]))

(mf/defc radio-boxes
  {::mf/register app/components
   ::mf/register-as :form/radio-boxes}
  [{:keys [name label options schema grid? square?]}]
  (let [t (hooks/use-t "form")]
    [:& form/field
     {:name name
      :label (t label)
      :validate (form/malli-validator t schema)
      :component
      (mf/fnc
       radio-boxes'
       [props]
       [:& form/box-radio
        (merge
         props
         (let [square-size-px 160]
           {:items options
            :container-render
            (if grid?
              (mf/fnc [{:keys [children]}]
                      [:> ch/SimpleGrid
                       {:gap 4
                        :template-columns (str "repeat(auto-fit, "
                                               (if square?
                                                 (str square-size-px "px")
                                                 "minmax(120px, 1fr)")
                                               ")")
                        :align-items :stretch
                        :justify-content :center}
                       children])
              ch/VStack)
            :item-render
            (mf/fnc item-render
                    [{:keys [item props]}]
                    (let [label (:label item)]
                      (j/assoc!
                       props
                       :rounded (if square? "lg" "2xl")
                       :border "1px solid var(--chakra-colors-brand-500)"
                       :px 4
                       :py 2
                       :textAlign "center"
                       :cursor "pointer"
                       :color "brand.500"
                       :opacity (when (:disabled item) "0.4")
                       :h (cond
                            square? square-size-px
                            grid? "100%"
                            :else "")
                       :display "flex"
                       :justifyContent "center"
                       :alignItems "center"
                       :fontWeight 600
                       :_checked #js {:color "#fff"
                                      :fontWeight "bold"
                                      :backgroundColor "var(--chakra-colors-brand-500)"})
                      [:> ch/Box
                       props
                       [:> ch/Box {}
                        (if (map? label)
                          (t label)
                          label)]]))}))])}]))

(mf/defc radio-boxes-2
  {::mf/register app/components
   ::mf/register-as :form/radio-boxes-2}
  [{:keys [name label tooltip options schema
           texts
           labels
           badges]}]
  (let [t (hooks/use-t "form")]
    [:& form/field
     {:name name
      :label (t label)
      :tooltip (t tooltip)
      :component ch/RadioGroup
      :validate (form/malli-validator t schema)
      :format (fn [x] (pr-str x))
      :parse (fn [x] (edn/read-string x))
      :cmp-params
      {:children
       [(mf/html
         [:> ch/Stack {:key "1" :gap 4 :align-items :center}
          (for [x options]
            [:> ch/Radio
             {:size :lg
              :bg :white
              :key (:value x)
              :value (pr-str (:value x))
              :align-items :center
              :justify-content :stretch}
             (if-let [c (:content x)]
               c
               [:> ch/Box
                {:pb 4
                 :border-color :border-primary.500
                 :border-width 1
                 :rounded :md
                 :text-align :center
                 :w "272px"}
                [:> ch/Box
                 {:mb 4
                  :border-top-radius :md
                  :background-color :surface-secondary.200
                  :font-size "16px"
                  :font-weight 700}
                 (t (get badges (:value x)))]
                [:> ch/Text {:font-size "16px" :font-weight 700 :color :border-primary.500}
                 (t (get labels (:value x)))]
                [:> ch/Text {:font-size "16px" :font-weight 500}
                 (t (:label x))]])])])]}}]))

(mf/defc label
  {::mf/register app/components
   ::mf/register-as :form/label}
  [{:keys [label]}]
  (let [t (hooks/use-t "form")]
    [:> ch/FormLabel
     {:mt 4}
     (t label)]))

(mf/defc paragraph
  {::mf/register app/components
   ::mf/register-as :form/paragraph}
  [{:keys [text html color font-weight text-align]}]
  (let [t (hooks/use-t "form")]
    [:> ch/Text
     {:my 4
      :color color
      :font-weight font-weight
      :text-align text-align}
     (if html
       [:span {:dangerouslySetInnerHTML #js {:__html (t html)}}]
       (t text))]))

(mf/defc text
  {::mf/register app/components
   ::mf/register-as :form/text}
  [{:keys [name label placeholder schema number? phone? footnote]}]
  (let [t (hooks/use-t "form")]
    [:& form/field
     {:name name
      :label (t label)
      :component ch/Input
      :validate (form/malli-validator t schema)
      :parse (cond
               number? (fn [x] (.replace x #"[^0-9]" ""))
               phone? (fn [x] (.replace x #"[^0-9+]" ""))
               :else js/undefined)
      :footnote (t footnote)
      :cmp-params
      {:bg :white
       :size "lg"
       :placeholder (t placeholder)}}]))

(mf/defc textarea
  {::mf/register app/components
   ::mf/register-as :form/textarea}
  [{:keys [name label placeholder tooltip schema]}]
  (let [t (hooks/use-t "form")]
    [:& form/field
     {:name name
      :label (t label)
      :tooltip (t tooltip)
      :component ch/Textarea
      :validate (form/malli-validator t schema)
      :cmp-params {:placeholder (t placeholder)}}]))

(mf/defc checkbox
  {::mf/register app/components
   ::mf/register-as :form/checkbox}
  [{:keys [name label schema html-label size]}]
  (let [t (hooks/use-t "form")]
    [:> ch/Box {:text-align :left}
     [:& form/field
      {:name name
       :component ch/Checkbox
       :type "checkbox"
       :validate (form/malli-validator t schema)
       :initialValue false
       :cmp-params {:align-items "center"
                    ;:mt 4
                    :children
                    (mf/html [:> ch/Text {:font-size (or size "lg")}
                              (when (= (m/type schema) :and) ;; fixme, form now assumption that [:and = true]
                                [:> ch/Text {:as "span" :color :red.500} "* "])
                              (t label)
                              (when html-label
                                [:span {:dangerouslySetInnerHTML #js {:__html (t html-label)}}])])}}]]))

(mf/defc checkboxes
  {}
  [{:keys [name label tooltip schema options]}]
  (let [t (hooks/use-t "form")]
    [:& form/field
     {:name name
      :label (t label)
      :tooltip (t tooltip)
      :component ch/CheckboxGroup
      :validate (form/malli-validator t schema)
      :format (fn [x] (into-array x))
      :parse (fn [x] (set x))
      :initialValue #{}
      :cmp-params {:align-items "baseline"
                   :size "lg"
                   :mt 4
                   :children
                   (mf/html
                    [:*
                     [:> ch/VStack
                      {:align :left
                       :mt 4}
                      (for [x options]
                        [:> ch/Checkbox {:value x} x])]])}}]))

(mf/defc hidden
  {::mf/register app/components
   ::mf/register-as :form/hidden}
  [{:keys [name value]}]
  (let [value (case value
                :url js/window.location.pathname
                value)]
    [:& form/field
     {:name name
      :initialValue value
      :type "hidden"
      :component "input"}]))

(mf/defc info
  {::mf/register app/components
   ::mf/register-as :form/info}
  [{:keys [text]}]
  (let [t (hooks/use-t "form")]
    [:> ch/Alert {:status :info}
     [:> ch/AlertIcon {}]
     (t text)]))

(mf/defc number-input
  [{:keys [name label schema min max]}]
  (let [t (hooks/use-t "form")]
    [:& form/field
     {:name name
      :label (t label)
      :component ch/NumberInput
      :validate (form/malli-validator t schema)
      :parse #(js/parseInt %)
      :initialValue min
      :cmp-params
      {:min min
       :max max
       :children
       [(mf/html
         [:*
          [:> ch/NumberInputField {}]
          [:> ch/NumberInputStepper {}
           [:> ch/NumberIncrementStepper {}]
           [:> ch/NumberDecrementStepper {}]]])]}}]))

(mf/defc number-big-input-field
  {::mf/wrap-props false}
  [props]
  (let [{:keys [getInputProps
                getIncrementButtonProps
                getDecrementButtonProps]}
        (->clj (ch/useNumberInput props))

        button-props (fn [plus?]
                       (clj->js {:size "lg"
                                 :rounded "full"
                                 :variant "outline"
                                 :colorScheme "brand"
                                 :border "3px solid"
                                 :w "60px"
                                 :h "60px"
                                 :icon (mf/html [:> ch/Icon {:as (if plus? icons/FaPlus icons/FaMinus)}])}))
        inc (getIncrementButtonProps (button-props true))
        dec (getDecrementButtonProps (button-props false))
        input (getInputProps #js {:width "100px"
                                  :fontSize "48px"
                                  :lineHeight "1em"
                                  :height "56px"
                                  :textAlign "center"
                                  ;:fontWeight "bold"
                                  :variant "ghost"
                                  :bg "transparent"
                                  :isReadOnly true})]
    [:> ch/HStack {:w "100%" :justify :center :my 4}
     [:> ch/IconButton dec]
     [:> ch/Input input]
     [:> ch/IconButton inc]]))

(mf/defc number-big-input
  [{:keys [name label schema item-label min max]}]
  (let [t (hooks/use-t "form")]
    [:> ch/Box {}
     [:& form/field
      {:name name
       :label (t label)
       :component number-big-input-field
       :validate (form/malli-validator t schema)
       :parse #(js/parseInt %)
       :initialValue min
       :cmp-params {:min min
                    :max max}}]
     [:> ch/Text
      {:font-weight 700
       :font-size :xl
       :text-align :center
       :white-space :pre-wrap
       :mb 4}
      (t item-label)]]))

(mf/defc subform
  {::mf/register app/components
   ::mf/register-as :form/subform}
  [params]
  (let [t (hooks/use-t "form")]
    [:div {}
     (when-let [title (:label params)]
       [:> ch/FormLabel {}
        (t title)])
     [:> ch/HStack {:align :start}
      (for [[i x] (map-indexed vector (-> params :fields))]
        [:* {:key i}
         (if (:name params)
           (app/render-cmp (update x
                                   :name (fn [n] (str (name (:name params))
                                                      "."
                                                      (name n)))))
           (app/render-cmp x))])]]))

;; fixme
(def order-value-to-track (atom nil))

;; move, fixme
(defn format-money [x]
  (some-> x
          (.toFixed 2)
          (string/replace ".00" "")
          (string/replace "." ",")))

(mf/defc confirmation
  {::mf/register app/components
   ::mf/register-as :form/confirmation}
  [{:keys [footnote short?]}]
  (let [t (hooks/use-t "form")
        values (:values (->clj (rff/useFormState)))
        {:keys [offer-id provider-id]} (mf/use-ctx offer-ctx)
        summary-query (s/use-query ["preorder-summary"]
                                   #(api/tx :offer/tx (merge values
                                                             {:handler-id :order/preorder-summary
                                                              :offer-id offer-id
                                                              :provider-id provider-id}))
                                   {})
        {:keys [pricing-items total payments amount-now summary-items offer-name]} (get-in summary-query [:data])
        collapsed (mf/use-state true)
        _ (reset! order-value-to-track total)]
    [:> ch/Box {}
     [:> ch/Box
      {:px 4
       :py 2
       :my 4
       :border-color :border-primary.500
       :border-width 1
       :rounded :md}
      [:> ch/Text {:font-weight :bold}
       (t offer-name)]
      (for [item summary-items
            :when item]
        [:> ch/Text {:key (hash (:label item))}
         (t (:label item))
         ": "
         [:b (t (:value item))]])

      (when-not short?
        (for [[i x] (map-indexed vector pricing-items)
              :when (:desc x)]
          [:> ch/Text {:key i}
           (t (:desc x))
           ": "
           [:b
            (when (:price x)
              (str
               (format-money (:price x)) " PLN"
               (when-let [per (:per x)]
                 (str " / " ({:month "msc"} per)))))
            (when (:percent-discount x)
              (str (:percent-discount x) " %"))]]))

      (when-not short?
        [:> ch/Text {}
         (t {:pl "Razem do zapłaty: " :en "Total amount to pay: "})
         [:b (str (format-money total) " PLN")]])

      (when (> (count payments) 1)
        [:*
         [:> ch/Divider
          {:border-style :dashed
           :border-color :border-primary.500
           :border-width 1
           :my 4}]
         [:> ch/Box {:position :relative}
          (when (> (count payments) 2)
            [:> ch/Button
             {:variant :ghost
              :on-click #(swap! collapsed not)
              :position :absolute
              :top 1
              :right 1}
             [:> ch/Box {:transition "transform 0.3s"
                         :transform (if @collapsed "rotate(0deg)" "rotate(180deg)")}
              [:& iconify/Icon
               {:icon "material-symbols:arrow-drop-down"
                :width 32
                :height 32}]]])
          [:> ch/Collapse
           {:in (not @collapsed)
            :startingHeight 50}
           (for [[i x] (map-indexed vector payments)
                 :when (:desc x)]
             [:> ch/Text {}
              (t (:desc x))
              ": "
              [:b (str (:amount x)) " PLN"]])]]])

      [:> ch/Divider
       {:border-style :dashed
        :border-color :border-primary.500
        :border-width 1
        :my 4}]

      [:> ch/Text
       {:font-weight :bold
        :font-size :2xl
        :text-align :center}
       (when-not short?
         [:*
          (t {:pl "Do zapłaty teraz:" :en "Total amount to pay now:"}) [:br]])
       (str (format-money amount-now) " PLN")
       (when-let [desc (:desc (first payments))]
         [:> ch/Text
          {:font-size :md
           :font-weight :normal}
          (t {:pl "(za: " :en "(for: "})  [:b (str (t desc))] ")"])]]

     (when footnote
       [:> ch/Text
        {:font-size :xs
         :m 4
         :text-align :center}
        (t footnote)])]))

(mf/defc copy-defaults
  {::mf/register app/components
   ::mf/register-as :form/copy-defaults}
  [{:keys [from to only]}]
  (let [form (rff/useForm)
        values (:values (->clj (rff/useFormState)))
        from-values (cond-> (get-in values from)
                      only (select-keys only))]
    (mf/with-effect
      [(hash from-values)]
      (let [vals (merge from-values
                        (get-in values to))]
        (js/setTimeout
         (fn []
           (.change
            form
            (form/field-name to)
            (->js vals)))
         100)))))

(def local-form-path-ctx (mf/create-context []))
(def local-form-path-provider (mf/provider local-form-path-ctx))

(defmulti schema-renderer*
  (fn [s opts]
    (let [ui-type (some-> (m/properties s) :ui/type)]
      (or
       ui-type
       (m/type s)))))

(defn get-relative-path-value
  ([path relative-path]
   (get-relative-path-value (:values (->clj (rff/useFormState))) path relative-path))
  ([form-values path relative-path]
   (let [path (concat
               (drop-last (count relative-path) path)
               (drop-while #{:..} relative-path))]
     (get-in form-values path))))

(defn- days-before? [days v]
  (let [[_ d m y1] (re-find #"^(\d\d?)\.(\d\d?)\.?(\d\d\d\d)?" (or v ""))
        y (or (some-> y1 parse-long) (tick/int (tick/year)))
        ;; when slot id does not have year, and month already passed, assume next year
        y (if (and (not y1)
                   (> (tick/int (tick/month)) m))
            (inc y)
            y)
        m (parse-long m)
        d (parse-long d)
        start-date (try
                     (tick/new-date y m d)
                     (catch js/Error e
                       (tick/today)))]
    (tick/<= (tick/today)
             (tick/<< start-date
                      (tick/new-period days :days)))))

(defn check-show-when-contition* [form-values condition path]
  (case (first condition)
    :contains?
    (let [[_ values cond-relative-path] condition
          v (get-relative-path-value form-values path cond-relative-path)]
      (contains? values v))

    :or
    (let [[_ & conditions] condition]
      (some #(check-show-when-contition* form-values % path) conditions))

    :and
    (let [[_ & conditions] condition]
      (every? #(check-show-when-contition* form-values % path) conditions))

    :not
    (not (check-show-when-contition* form-values (second condition) path))

    :pos?
    (let [[_ cond-relative-path] condition
          v (get-relative-path-value form-values path cond-relative-path)]
      (pos? v))

    :days-before?
    (let [[_ days cond-relative-path] condition
          v (get-relative-path-value form-values path cond-relative-path)]
      (days-before? days v))))

(defn check-show-when-contition [condition path]
  (let [form-values (:values (->clj (rff/useFormState)))]
    (check-show-when-contition* form-values condition path)))

(defn schema-renderer [s params]
  (let [show-when-condition (:ui/show-when (m/properties s))]
    (if (or (not show-when-condition)
            (check-show-when-contition show-when-condition (:path params)))
      (schema-renderer* s params)
      nil)))

(mf/defc wrapper
  {::mf/register app/components
   ::mf/register-as :form/wrapper}
  [{:keys [children] :as params}]
  (let [show-when-condition (:show-when params)] ;; :ui/show-when
    (if (or (not show-when-condition)
            (check-show-when-contition show-when-condition (:path params)))
      (for [[i x] (map-indexed vector children)]
        [:* {:key i}
         (app/render-cmp x)])
      nil)))

(mf/defc tt [{:keys [children]}]
  (let [t (hooks/use-t "form")]
    [:* (if (map? children)
          (t children)
          children)]))

(defmethod schema-renderer* :enum
  [s params]
  (let [props (m/properties s)
        options (or (:ui/options props)
                    (map #(do {:value %}) (m/children s)))
        labels (or (:texts params)
                   (:ui/labels (m/properties s)))
        cmp (cond
              (= (:as params) :radio-boxes) radio-boxes
              (= (:as params) :radio-boxes-2) radio-boxes-2
              (= (:as params) :radio) radio
              (= :hidden (:as params)) hidden
              :else select)
        filter-fn (or (:filter params)
                      (when-let [t (:tag-filter params)] #(contains? (:tags %) t))
                      (constantly true))]
    (mf/html
     [:& cmp
      (merge {:name (:path params)
              :options (->> options
                            (filter filter-fn)
                            (keep (fn [x]
                                    (let [v (or (:value x) (:id x))
                                          label (or (get labels v)
                                                    (str v))
                                          sublabel (and (map? label) (:sublabel label))
                                          label (or (and (map? label) (:label label)) label)]
                                      (when (not= label "")
                                        {:value v
                                         :disabled (or (:disabled x) (:disabled params))
                                         :label (if (= (:as params) :radio-boxes)
                                                  (mf/html [:> ch/Box {}
                                                            [:> ch/Text {:font-weight :bold :my 4 :font-family "var(--chakra-fonts-heading)" :font-size :lg}
                                                             [:& tt {} label]]
                                                            (when sublabel
                                                              [:> ch/Text {:my 4}
                                                               [:& tt {} sublabel]])
                                                            (when (and (:disabled-label params) (:disabled x))
                                                              [:> ch/Tag {:size :sm :display :block :mt 2}
                                                               [:& tt {} (:disabled-label params)]])])
                                                  label)})))))
              :grid? (:grid? params)
              :schema s}
             params)])))

(defmethod schema-renderer* :set
  [s params]
  (let [props (m/properties s)
        options (m/children (first (m/children s))) ;; [:set [:emum 1 2 3 4]]
        ;labels (:ui/labels (m/properties s))
        ]

    (mf/html
     [:& checkboxes
      (merge
       {:name (:path params)
        :schema s
        :options options}
       params)])))

(defmethod schema-renderer* :int
  [s params]
  (let [cmp (case (:as params)
              :big-buttons number-big-input
              :hidden hidden
              number-input)
        {:keys [min max]} (m/properties s)]
    (mf/html
     [:& cmp
      (merge {:name (:path params)
              :schema s
              :min min
              :max max}
             params)])))

(defmethod schema-renderer* :boolean
  [s params]
  (let [texts (:texts params)]
    (cond
      (= :hidden (:as params)) (mf/html [:& hidden (merge {:name (:path params) :schema s} params)])

      texts
      (mf/html
       [:& radio
        (merge {:name (:path params)
                :disabled (:disabled params)
                :options [{:value true :label (texts true)}
                          {:value false :label (texts false)}]
                :schema s}
               params)])
      :else
      (mf/html
       [:& checkbox
        (merge {:name (:path params)
                :schema s}
               params)]))))

(defmethod schema-renderer* :string
  [s params]
  (let [props (m/properties s)
        max-len (:max props)
        number? (:number props)
        phone? (:phone props)
        cmp (cond
              (= :hidden (:as params)) hidden
              (and max-len
                   (> max-len 200)) textarea
              :else text)]
    (mf/html
     [:& cmp
      (merge {:name (:path params)
              :number? number?
              :phone? phone?
              :schema s}
             params)])))

(defmethod schema-renderer* :maybe
  [s params]
  (let [s2 (first (m/children s))]
    (schema-renderer s2
                     (assoc params
                            :schema s))))

(defmethod schema-renderer* :and ;; render for first elem and validate whole schema
  [s params]
  (let [s2 (first (m/children s))]
    (schema-renderer s2
                     (assoc params
                            :schema s))))

(defmethod schema-renderer* :email
  [s params]
  (let [s2 (first (m/children s))]
    (schema-renderer s2
                     (assoc params
                            :schema s))))

(defmethod schema-renderer* :phone
  [s params]
  (let [s2 (first (m/children s))]
    (schema-renderer s2
                     (assoc params
                            :schema s))))

(mf/defc slot-date-time
  [{:keys [days name label-day label-time]}]
  (let [t (hooks/use-t "form")
        form (rff/useForm)
        values (:values (->clj (rff/useFormState)))
        date (get-in values (conj name :date))
        prev-date (mf/use-ref date)]
    (mf/with-effect
      [date]
      (when (and date (not= date (.-current prev-date)))
        (set! (.-current prev-date) date)
        (.change form (form/field-name (conj name :slot-id)) nil)))
    [:> ch/Box {}
     [:> ch/FormLabel {}
      (t label-day)]
     (app/render-cmp
      {:app/component :manubbies/day-picker
       :days days
       :name (conj name :date)})
     (when date
       (let [slots (get days date)
             ids (sort (map :id slots))
             labels (into {} (map (fn [s] [(:id s) (str (:time s))]) slots))]
         [:*
          [:> ch/FormLabel {}
           (t label-time)]
          (schema-renderer
           (m/schema (vec (concat [:enum
                                   {:ui/labels labels}]
                                  ids)))
           {:name (conj name :slot-id)
            :as :radio-boxes})]))]))

(defmethod schema-renderer* :slot-date-time
  [s params]
  (let [props (m/properties s)
        days (:options props)]
    (mf/html
     [:& slot-date-time
      (merge
       {:days days
        :name (:path params)}
       params)])))

(defmethod schema-renderer* :weekly-time-slot
  [s params]
  (app/render-cmp {:app/component :manubbies/weekly-slots-calendar
                   :schema s
                   :params params}))

(defn vec-remove
  "remove elem in coll"
  [pos coll]
  (into (subvec coll 0 pos) (subvec coll (inc pos))))

(mf/defc repeat-form [{:keys [schema params]}]
  (let [t (hooks/use-t "form")
        schema-props (m/properties schema)
        dyn-count (when-let [p (:ui/dynamic-count schema-props)]
                    (or (get-relative-path-value (:path params) p)
                        (:min schema-props 0)))
        min-count (or dyn-count (:min schema-props 0))
        max-count (or dyn-count (:max schema-props 100))
        count-state (mf/use-state min-count)
        count (or dyn-count @count-state)
        content (:content params)
        form (rff/useForm)
        remove-item! (fn [idx]
                       (let [values (:values (->clj (.getState form)))]
                         (swap! count-state dec)
                         (.change form
                                  (form/field-name (:path params))
                                  (->js (vec-remove idx (get-in values (:path params)))))))]
    [:div {}
     (when-let [label (:label params)]
       [:> ch/FormLabel {}
        (t label)])

     [:> ch/Box {}
      (for [i (range count)]
        [:> ch/Box {:key i}
         (when-let [label (:items-label-prefix params)]
           [:> ch/Flex
            {:justify :space-between}
            [:> ch/FormLabel {}
             (str (t label) " " (inc i))]
            (when (> count min-count)
              [:> ch/CloseButton
               {:size :sm
                :on-click #(remove-item! i)}])])

         [:& local-form-path-provider
          {:value (conj (:path params) i)}
          (for [c content]
            [:div {:key (hash c)}
             (app/render-cmp c)])]])
      (when (< count max-count)
        [:> ch/Button
         {:color-scheme :brand
          :size :sm
          :on-click #(swap! count-state inc)}
         [:> ch/Icon {:as icons/FaPlus :mr 2}]
         "Dodaj"])]]))

(defmethod schema-renderer* :repeat
  [s params]
  (mf/html
   [:& repeat-form
    {:schema s
     :params params}]))

(defmethod schema-renderer* :default
  [s params]
  (mf/html
   [:> ch/Box {:bg :gray.50}
    [:p {} (pr-str (m/form s) params)]]))

(mf/defc claims-field
  {::mf/register app/components
   ::mf/register-as :form/claims-field}
  [{:keys [path label] :as params}]
  (let [claim-schema (:claim-schema (mf/use-ctx offer-ctx))
        path-prefix (mf/use-ctx local-form-path-ctx)
        path (vec (concat path-prefix path))
        params (-> params
                   (assoc :path path))
        schema-path (vec (map #(if (number? %) 0 %) path)) ;; fixme, for :repeat schema
        field-schema (mu/get-in claim-schema schema-path)]
    #_(js/console.log "claims-field" {:claim-schema (m/form claim-schema)
                                      :field-schema (m/form field-schema)
                                      :path path})
    (schema-renderer field-schema params)))

(mf/defc select-all-button
  {::mf/register app/components
   ::mf/register-as :form/select-all}
  [{:keys [paths size label]}]
  (let [t (hooks/use-t "form")
        form-values (:values (->clj (rff/useFormState)))
        form (rff/useForm)
        values (map #(get-in form-values %) paths)
        selected? (every? identity values)
        select-all! (fn []
                      (doseq [p paths]
                        (.change form (form/field-name p) (not selected?))))]
    [:> ch/Checkbox
     {:align-items "center"
      :size "lg"
      :mb 4
      :isChecked selected?
      :onChange select-all!}
     [:> ch/Text {:font-size (or size "lg")}
      (t label)]]))

(mf/defc progress-bar [{:keys [progress]}]
  [:> ch/Box
   {:position :relative
    :max-w 250
    :w "100%"
    :margin "0 auto 24px"}
   [:> ch/Box
    {:my "5px"
     :h "2px"
     :w "100%"
     :rounded "2px"
     :bg :surface-secondary.200}]
   [:> ch/Box
    {:my "5px"
     :h "2px"
     :w (str progress "%")
     :top 0
     :left "0"
     :rounded "2px"
     :position :absolute
     :bg :border-primary.500}]
   [:> ch/Box
    {:w "12px"
     :h "12px"
     :rounded :full
     :background :border-primary.500
     :position :absolute
     :top "0"
     :left (str progress "%")}]])

(def focus-on-errors (final-form-focus/default))

;; workaround for bug with initial values
(mf/defc set-forms-initial-values
  [{:keys [values]}]
  (let [form (rff/useForm)]
    (mf/with-effect
      []
      (.reset form (->js values)))))

;; todo split form/steps
(mf/defc steps
  {::mf/register app/components
   ::mf/register-as :form/steps}
  [{:keys [steps claims-schema pricing offer-id offer-name provider-id order-id show-step-dots?
           offline-payment confirm-text non-sticky-buttons? go-back! inline-form? thx-text
           handler-id center-aligned? initial-values toast-feedback? tracking] :as params}]
  (let [t (hooks/use-t "form")
        active-step (mf/use-state 0)
        next-step! (fn [] (reset! active-step inc))
        prev-step! (fn [] (reset! active-step dec))
        steps (filterv some? steps)
        steps-num (count steps)
        toast (ch/useToast)
        on-error (fn [err variables context]
                   (js/console.error "Mutate error" err variables context)
                   (track "Error during order form submittion" {})
                   (toast #js {:title (or
                                       (some-> err :body :data :response :message (t))
                                       "Error occured")
                               :status "error"}))
        on-success (fn [response {:keys [main] :as _variables} _context]
                     (track "Order submitted" {})
                     (when (some #{:newsletter} tracking)
                       (track :newsletter (get-tracking-params
                                           {:type :newsletter
                                            :provider-id provider-id
                                            :user main})))

                     (when-let [email (:customer-email response)]
                       (tracking/identify email)
                       (tracking/people-set {"$email" email})
                       (tracking/people-increment {"Orders count" 1})
                       (tracking/people-union {"Client of" provider-id}))

                     (when inline-form?
                       (next-step!))
                     (when toast-feedback?
                       (toast #js {:status "success"
                                   :title thx-text
                                   :isClosable true}))
                     (when-let [redirect (:redirect response)]
                       (rfe/push-state (:screen redirect) redirect)))
        {:keys [isLoading mutate]} (s/use-tx :offer/tx
                                             {:on-error on-error
                                              :on-success on-success})
        steps (if inline-form?
                (conj steps {:content [{:app/component :text :text thx-text :align "center"}]})
                steps)
        step (nth steps @active-step)
        show-step-dots? (if (nil? show-step-dots?) true show-step-dots?)
        order-form-state (mf/with-memo (s/atom {}))
        with-payment? (:with-payment? @(s/use-atom order-form-state))
        last-step? (= (inc @active-step) steps-num)
        preorder-summary (mf/use-state nil)
        fetch-preorder-summary!
        (fn [values]
          (p/then
           (api/tx
            :offer/tx
            (merge values
                   {:handler-id :order/preorder-summary
                    :offer-id offer-id
                    :provider-id provider-id}))
           (fn [x]
             (reset! preorder-summary x))))
        schema (mf/with-memo
                 (m/schema claims-schema))

        initial-values (mf/with-memo
                         (or initial-values {}))]

    (mf/with-effect
      [@active-step]
      (track "Form step view"
             {"Current step" @active-step
              "Total steps" steps-num}))

    [:& offer-ctx-provider
     {:value
      {:claim-schema schema
       :pricing pricing
       :offer-id offer-id
       :provider-id provider-id
       :preorder-summary @preorder-summary
       :order-form-state order-form-state}}
     [:& form/form
      {:decorators #js [focus-on-errors]
       :on-submit (fn [values _form]
                    (if-not last-step?
                      (do
                        (js/window.scrollTo 0 0)
                        (fetch-preorder-summary! (->clj values))
                        (next-step!))
                      (mutate (-> values
                                  ->clj
                                  (assoc :handler-id (or handler-id :order/submit)
                                         :offer-id offer-id
                                         :order-id order-id
                                         :provider-id provider-id
                                         :language (language))))))
       :initial-values {}}
      [:& set-forms-initial-values
       {:values initial-values}]
      [:> ch/Flex {:direction :column
                   :align :center
                   :px 4
                   :min-h (when-not non-sticky-buttons? "calc(100svh - 82px)")}
       [:> ch/Heading {:size :md :font-size 24 :my 4}
        (t offer-name)]
       (when show-step-dots?
         (let [progress (* 100 (/ @active-step steps-num))]
           [:& progress-bar {:progress progress}]))

       [:> ch/Flex
        {:direction :column
         :w :full
         :flex 1
         :text-align (when center-aligned? "center")}
        (when-let [title (:title step)]
          [:*
           [:> ch/Text
            {:text-align :center
             :color :border-primary.500
             :font-weight 600
             :mb 4}
            (t title)
            (when-not show-step-dots?
              (str " (" (inc @active-step) "/" steps-num ")"))]
           #_[:> ch/Divider {:my 4}]])
        (for [c (:content step)]
          (when c
            (app/render-cmp (assoc c :key (hash c)))))]

       [:> ch/Flex
        {:w "101%"
         :justify :center
         :z-index 5
         :position (when-not non-sticky-buttons? "sticky")
         :bottom 0
         :bg (when-not non-sticky-buttons? "linear-gradient(rgba(255,255,255,0), rgba(255,255,255,1) 16px)")
         :py 4
         ;; key is workaround for dom mutation problem when user uses page translator
         ;; https://issues.chromium.org/issues/41407169
         ;; https://github.com/facebook/react/issues/11538
         :key (str "k" @active-step last-step?)}
        (when (or go-back! (< 0 @active-step steps-num))
          [:> ch/Button
           {:size :lg
            :font-family "var(--chakra-fonts-heading)"
            :font-weight 800
            :variant :outline
            :on-click (if (pos? @active-step) prev-step! go-back!)
            :colorScheme "border-primary"
            :mx 2
            :min-w (when-not last-step? "150px")
            :h "64px"}
           [:*
            [:& iconify/Icon
             {:icon "material-symbols:arrow-back-ios-rounded"
              :width 24
              :height 24}]
            (when-not last-step?
              (t "back"))]])
        (when (<= (inc @active-step) steps-num) ;; active-step == steps-num for inline confiration step
          [:> ch/Button
           {:size :lg
            :bg (when last-step? "#2E8540")
            :_hover {:bg (when last-step? "#2E8540")}
            :font-family "var(--chakra-fonts-heading)"
            :font-weight 800
            :colorScheme "border-primary"
            :type "submit"
            :is-disabled isLoading
            :mx 2
            :min-w "150px"
            :white-space :pre-wrap
            :h "64px"}
           (if last-step?
             [:*
              (cond
                confirm-text (t confirm-text)
                offline-payment (t "confirm-pay-later")
                with-payment? (t "confirm-and-pay")
                :else (t "confirm-and-order"))
              [:& iconify/Icon
               {:icon "material-symbols:check-rounded"
                :style #js {:marginLeft "8px"}
                :width 24
                :height 24}]]
             [:*
              (t "next")
              [:& iconify/Icon
               {:icon "material-symbols:arrow-forward-ios-rounded"
                :style #js {:marginLeft "8px"}
                :width 24
                :height 24}]])])]]]]))

(mf/defc participants-validate
  {::mf/register app/components
   ::mf/register-as :manubbies/participants-validate}
  [{:keys [path label] :as params}]
  (let [claim-schema (:claim-schema (mf/use-ctx offer-ctx))
        slots (get (m/properties (mu/get-in claim-schema [:main :slot]))
                   :ui/options)]
    [:& form/field
     {:name [:main]
      :type "hidden"
      :component "input"
      :validate (fn [values]
                  (let [v (->clj values)
                        limit (or (some->> slots
                                           (filter #(= (:id %) (:slot v)))
                                           first
                                           :left)
                                  0)
                        num (+ (:adults-number v 0) (:kids-number v 0))]
                    (seq
                     (filter
                      identity
                      [(when (zero? num)
                         "Wybierz liczbę osób")
                       (when (> num limit)
                         (if (pos? limit)
                           (str "Pozostało tylko " limit " wolne miejsca")
                           "Brak wolnych miejsc"))]))))}]))
